import { apiGet, apiPost } from './api';

export type SubscriptionRow = {
  _id: string;
  status: string;
  startDate?: string;
  endDate?: string;
  trialEndDate?: string;
  isTrial?: boolean;
  canceledAt?: string;
  cancellationReason?: string;
  planId?: { name?: string; price?: number; currency?: string };
};

export async function getUserSubscriptions(userId: string) {
  return apiGet<{
    success: boolean;
    currentSubscription: SubscriptionRow | null;
    subscriptions: SubscriptionRow[];
  }>(`/api/v1/admin/users/${userId}/subscriptions`);
}

export async function getUserSubscriptionHistory(userId: string, page = 1) {
  return apiGet<{
    success: boolean;
    history: Array<{
      _id: string;
      action: string;
      description?: string;
      createdAt: string;
      previousStatus?: string;
      newStatus?: string;
    }>;
    pagination: { page: number; limit: number; total: number; pages: number };
  }>(`/api/v1/admin/users/${userId}/subscriptions/history?page=${page}&limit=20`);
}

export async function getUserTransactions(userId: string, page = 1) {
  return apiGet<{
    success: boolean;
    transactions: Array<{
      _id: string;
      transactionId?: string;
      paymentMethod?: string;
      gatewayName?: string;
      amount?: number;
      currency?: string;
      paymentStatus?: string;
      transactionDate?: string;
      transactionType?: string;
    }>;
    pagination: { page: number; limit: number; total: number; pages: number };
  }>(`/api/v1/admin/users/${userId}/transactions?page=${page}&limit=20`);
}

export async function cancelSubscription(userId: string, subscriptionId: string, reason?: string) {
  return apiPost(`/api/v1/admin/users/${userId}/subscriptions/${subscriptionId}/cancel`, { reason });
}

export async function reactivateSubscription(userId: string, subscriptionId: string) {
  return apiPost(`/api/v1/admin/users/${userId}/subscriptions/${subscriptionId}/reactivate`, {});
}

export async function extendTrial(userId: string, subscriptionId: string, days: number) {
  return apiPost(`/api/v1/admin/users/${userId}/subscriptions/${subscriptionId}/extend-trial`, { days });
}

export async function grantCompAccess(userId: string, days: number, planId?: string) {
  return apiPost(`/api/v1/admin/users/${userId}/grant-access`, { days, planId });
}
